module.exports = __webpack_public_path__ + "media/images/flags/16/Aland-281f622d0283cb6f5b2600e9317c44ac.png";